// extracted by mini-css-extract-plugin
export default {"Box_0":"FilterInputWrapper-module__Box_0--chXAO","Box_1":"FilterInputWrapper-module__Box_1--vewob"};